import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@/components/common/ui/Button';
import Favorite from '@material-ui/icons/Favorite';
import styles from 'styles/jss/original/components/menus/detailTitle';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import CurrencyFormat from 'react-currency-format';
import { IMenu } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  menu: IMenu;
  onRequestUpdateFavorite: (id: string) => void;
  isFavorite: boolean;
  invalid: boolean;
};

const DetailTitle: React.FC<ComponentProps> = ({
  menu,
  onRequestUpdateFavorite,
  isFavorite,
  invalid
}) => {
  const { id, title, slug, cat, type, time, cost } = menu.fields;
  const classes = useStyles();
  const handleClick = useCallback(
    (id: string) => {
      onRequestUpdateFavorite(id);
    },
    [onRequestUpdateFavorite]
  );
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <ul className={classes.snsIcon}>
          <li className={classes.flexItem}>
            <TwitterShareButton
              url={`https://smalldish.jp/menus/${slug}`}
              title={`${title} | smalldish`}
            >
              <Button color='white' round justIcon>
                <i className='fab fa-twitter' />
              </Button>
            </TwitterShareButton>
          </li>
          <li className={classes.flexItem}>
            <FacebookShareButton url={`https://smalldish.jp/menus/${slug}`}>
              <Button color='white' round justIcon>
                <i className='fab fa-facebook-f' />
              </Button>
            </FacebookShareButton>
          </li>
        </ul>
        <h1 className={classes.title}>{title}</h1>
        <ul className={classes.info}>
          <li>
            <b>対象：</b>
            {type}
          </li>
          <li>
            <b>カテゴリー：</b>
            {cat}
          </li>
          <li>
            <b>時間目安：</b>
            {time && `${time}分`}
          </li>
          <li>
            <b>費用目安：</b>
            <CurrencyFormat
              value={cost}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'¥'}
            />
          </li>
        </ul>
        <div className={classes.action}>
          <Button
            color='warning'
            round
            onClick={() => handleClick(id)}
            disabled={invalid}
            className={classes.flexItem}
          >
            <Favorite color={isFavorite ? 'secondary' : 'inherit'} />
            お気に入り
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DetailTitle;
